/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentDeleteAiScanTarget } from "../funcs/agentDeleteAiScanTarget.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DeleteAiScanTargetResult } from "../models/components/deleteaiscantargetresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAiScanTargetRequest,
  DeleteAiScanTargetSecurity,
} from "../models/operations/deleteaiscantarget.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteAiScanTargetMutationVariables = {
  request: DeleteAiScanTargetRequest;
  security?: DeleteAiScanTargetSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteAiScanTargetMutationData = DeleteAiScanTargetResult;

export type DeleteAiScanTargetMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteAiScanTarget agent
 *
 * @remarks
 * Remove a target the organization added, or clear the row a built-in carries so it returns to having no recorded decision. A built-in itself cannot be removed here; it leaves the list only by leaving Speakeasy's catalog. Requires a session with the org:admin scope.
 */
export function useDeleteAiScanTargetMutation(
  options?: MutationHookOptions<
    DeleteAiScanTargetMutationData,
    DeleteAiScanTargetMutationError,
    DeleteAiScanTargetMutationVariables
  >,
): UseMutationResult<
  DeleteAiScanTargetMutationData,
  DeleteAiScanTargetMutationError,
  DeleteAiScanTargetMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteAiScanTargetMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteAiScanTarget(): MutationKey {
  return ["@gram/client", "agent", "deleteAiScanTarget"];
}

export function buildDeleteAiScanTargetMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteAiScanTargetMutationVariables,
  ) => Promise<DeleteAiScanTargetMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteAiScanTarget(),
    mutationFn: function deleteAiScanTargetMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteAiScanTargetMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentDeleteAiScanTarget(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
